import { ApolloError, useMutation } from '@apollo/client';
import {
  GameDifficulty,
  SetGameDifficulty,
  SetGameDifficultyVariables,
} from '../../../graphql/types';
import { setGameDifficultyMutation } from '../operations';

interface Options {
  reload?: boolean;
  onCompleted?: (difficulty: GameDifficulty) => void;
  onError?: (error: ApolloError) => void;
}

const useSetGameDifficulty = (options?: Options) => {
  const { reload = true, onCompleted, onError } = options || {};
  return useMutation<SetGameDifficulty, SetGameDifficultyVariables>(
    setGameDifficultyMutation,
    {
      onCompleted: (data) => {
        if (onCompleted) {
          onCompleted(data.setGameDifficulty.gameDifficulty);
        }
        if (reload) {
          // subscription, which contains auth user with game difficulty, needs to be recreating
          window.location.reload();
        }
      },
      onError,
    },
  );
};

export default useSetGameDifficulty;
